import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IoIosAdd } from "react-icons/io";
import { IoCloseOutline } from "react-icons/io5";
import useOnClickOutside from "../../components/UseOnClickOutside";
import DashLayout from "../../layouts/DashLayout";
import Overlay from "../../components/Overlay";
import { color, style } from "../../styles/Style";
import { ToastContainer } from "react-toastify";
import { projectStaff, roles } from "../../utils/DataSource";
import {
  getProfileInfo,
  getProfileInfoById,
  updateProfileInfo,
} from "../../store/actions/AccountActions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

function SettingsAccount() {
  const dispatch = useDispatch();
  const myProfile = useSelector((state) => state.stateOfProfiles.userAccount);

  const [openTab, setOpenTab] = useState(1);
  const [openOverlay, setOpenOverlay] = useState(0);
  const [openChangeRoleOverlay, setChangeRoleOverlay] = useState(0);
  const [profile, openProfile] = useState(0);
  const profileCard = useRef();
  useOnClickOutside(profileCard, () => openProfile(0));
  function overlayController() {
    setOpenOverlay(!openOverlay);
  }
  function changeRoleOverlayController() {
    setChangeRoleOverlay(!openChangeRoleOverlay);
    openProfile(0);
  }
  // getting user id from session
  const userId = JSON.parse(
    `${useSelector((state) => state.auth.session)}`
  ).userId;
  // load all profiles
  useEffect(() => {
    dispatch(getProfileInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // user declaration
  const [user, setUser] = useState(myProfile);

  const [uploadDetails, setUploadDetails] = useState({
    currentProfile: "",
    url: "",
    image: "",
  });
  function handleAccountUpdate(e) {
    e.preventDefault();
    const data = new FormData();
    if (uploadDetails.image) {
      data.append("file", uploadDetails.image);
      data.append("upload_preset", "he4nck0f");
      data.append("cloud_name", "hillsdev");
      fetch("https://api.cloudinary.com/v1_1/hillsdev/image/upload", {
        method: "post",
        body: data,
      })
        .then((resp) => resp.json())
        .then((data) => {
          accountUpdate(data.url);
        })
        .catch((err) => {
          accountUpdate(user.profilePicturePath);
          console.log(err);
        });
    } else {
      accountUpdate(user.profilePicturePath);
    }
  }

  // reload user account info
  useEffect(() => {
    dispatch(getProfileInfoById(userId));
  }, [dispatch, userId]);
  // handle assocciation update
  const accountUpdate = (profilepic) => {
    const id = user.id;
    const updatedProfile = {
      email: user.email,
      firstName: user.firstName,
      firstTelPhoneNumber: user.firstTelPhoneNumber,
      gender: user.gender,
      password: user.password,
      profilePicturePath: profilepic,
      roles: user.roles,
      secondName: user.secondName,
      secondTelPhoneNumber: user.secondTelPhoneNumber,
      username: user.username,
      status: "ACTIVE",
    };
    dispatch(updateProfileInfo(updatedProfile, id));
  };
  function handleImageChange(e) {
    setUser({
      ...user,
      currentProfile: user.profilePicturePath,
    });
    setUser({
      ...user,
      profilePicturePath: URL.createObjectURL(e.target.files[0]),
    });
    setUploadDetails({
      ...uploadDetails,
      image: e.target.files[0],
    });
  }
  return (
    <DashLayout>
      <div className="flex flex-wrap mr-10 ml-5">
        <div className="text-xs">
          <ToastContainer />
        </div>
        <div className="w-full mx-5 rounded">
          <ul
            className="flex mb-0 list-none flex-wrap pt-3  font-medium  flex-row w-full border-b border-gray-300 bg-white"
            role="tablist"
          >
            <li className="-mb-px  last:mr-0 pl-10">
              <a
                className={
                  "text-xs   mr-5 py-3 pl-0   block leading-normal" +
                  (openTab === 1
                    ? " text-indigo-500 border-b-2 border-" + color + "-600"
                    : "text-gray-500 ")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(1);
                }}
                data-toggle="tab"
                href="#link1"
                role="tablist"
              >
                <i className="fas fa-space-shuttle text-base mr-1"></i> My
                account
              </a>
            </li>
            <li className="-mb-px  last:mr-0">
              <a
                className={
                  "text-xs    mr-5 py-3  block leading-normal " +
                  (openTab === 2
                    ? "text-indigo-500 border-b-2 border-" + color + "-600"
                    : "text-gray-500")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(2);
                }}
                data-toggle="tab"
                href="#link2"
                role="tablist"
              >
                <i className="fas fa-cog text-base mr-1"></i> Password
              </a>
            </li>
            <li className="-mb-px  last:mr-0">
              <a
                className={
                  "text-xs   mr-5 py-3   block leading-normal " +
                  (openTab === 3
                    ? "text-indigo-500 border-b-2 border-" + color + "-600"
                    : "text-gray-500 ")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(3);
                }}
                data-toggle="tab"
                href="#link3"
                role="tablist"
              >
                <i className="fas fa-briefcase text-base mr-1"></i> Project
              </a>
            </li>
            <li className="-mb-px  last:mr-0">
              <a
                className={
                  "text-xs  mr-5 py-3 pl-0  block leading-normal " +
                  (openTab === 4
                    ? "text-indigo-500 border-b-2 border-" + color + "-600"
                    : "text-gray-500")
                }
                onClick={(e) => {
                  e.preventDefault();
                  setOpenTab(4);
                }}
                data-toggle="tab"
                href="#link3"
                role="tablist"
              >
                <i className="fas fa-briefcase text-base mr-1"></i> Employees
              </a>
            </li>
          </ul>

          <div className="relative flex flex-col min-w-0 break-words bg-white mb-6 rounded pl-10">
            <div className="p-5 pl-0">
              <div className="tab-content tab-space">
                <form
                  className={openTab === 1 ? "flex flex-col" : "hidden"}
                  id="link1"
                  onSubmit={handleAccountUpdate}
                >
                  <div className="flex flex-col md:flex-row">
                    {/* account settings */}
                    <div className="p-5 pl-0 flex flex-col w-full lg:w-3/5">
                      <h2 className="font-medium">Account settings</h2>
                      <div className={style.settingsInputs}>
                        {/* name field */}
                        <div className="py-2 w-full">
                          <label>Fist Name </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={user.firstName}
                              onChange={(e) => {
                                setUser({ ...user, firstName: e.target.value });
                              }}
                            />
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2 xl:ml-2 lg:ml-2 md:ml-2 ml-0 w-full">
                          <label>Last Name </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={user.secondName}
                              onChange={(e) => {
                                setUser({
                                  ...user,
                                  secondName: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className={style.settingsInputs}>
                        {/*  field */}
                        <div className="py-2  w-full">
                          <label>Email </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="email"
                              className={style.field.input}
                              value={user.email}
                              onChange={(e) => {
                                setUser({ ...user, email: e.target.value });
                              }}
                            />
                          </div>
                        </div>
                        {/*  field */}
                        <div className="py-2 xl:ml-2 lg:ml-2 md:ml-2 ml-0 w-full">
                          <label>Username </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={user.username}
                              onChange={(e) => {
                                setUser({ ...user, username: e.target.value });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className={style.settingsInputs}>
                        {/* name field */}
                        <div className="py-2 w-full">
                          <label>Telephone 1 </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={user.firstTelPhoneNumber}
                              onChange={(e) => {
                                setUser({
                                  ...user,
                                  firstTelPhoneNumber: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                        {/* name field */}
                        <div className="py-2 xl:ml-2 lg:ml-2 md:ml-2 ml-0 w-full">
                          <label>Telephone 2 </label>
                          <div className={style.field.parentDiv}>
                            <input
                              type="text"
                              className={style.field.input}
                              value={user.secondTelPhoneNumber}
                              onChange={(e) => {
                                setUser({
                                  ...user,
                                  secondTelPhoneNumber: e.target.value,
                                });
                              }}
                            />
                          </div>
                        </div>
                      </div>
                      {/* gender */}
                      <div className="flex">
                        <span className="text-gray-500 mr-2">Gender</span>
                        <div className="flex flex-row">
                          <div className="mr-2">
                            <label className="items-cente flex">
                              <input
                                type="radio"
                                className="form-radio m-auto"
                                name="gender"
                                value="MALE"
                                checked={user.gender === "MALE"}
                                onChange={(e) =>
                                  setUser({
                                    ...user,
                                    gender: e.target.value,
                                  })
                                }
                              />
                              <span className="ml-2 m-auto">Male</span>
                            </label>
                          </div>
                          <div>
                            <label className="inline-flex items-center">
                              <input
                                type="radio"
                                className="form-radio m-auto"
                                name="gender"
                                value="FEMALE"
                                checked={user.gender === "FEMALE"}
                                onChange={(e) =>
                                  setUser({
                                    ...user,
                                    gender: e.target.value,
                                  })
                                }
                              />
                              <span className="ml-2 m-auto">Female</span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* profile picture */}
                    <div className="w-2/5 m-auto">
                      <div className="py-3 center mx-auto">
                        <div className="md:py-5 py-auto md:px-4 rounded  text-center">
                          <div className="mb-4">
                            <img
                              className="md:w-32 md:h-32 w-20 h-20 rounded-full bg-gray-100 border-b-2 border-gray-300 object-cover object-center"
                              src={
                                user.profilePicturePath
                                  ? user.profilePicturePath
                                  : "https://i1.pngguru.com/preview/137/834/449/cartoon-cartoon-character-avatar-drawing-film-ecommerce-facial-expression-png-clipart.jpg"
                              }
                              alt="Avatar Upload"
                            />
                          </div>
                          <label className="cursor-pointer mt-6">
                            <div className="-mt-10 ml-10 absolute  leading-normal  p-2  bg-indigo-500 text-white text-sm rounded-full">
                              <IoIosAdd className="text-white" />
                            </div>
                            <input
                              type="file"
                              className="hidden"
                              multiple="multiple"
                              accept="image/*"
                              onChange={handleImageChange}
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="md:w-3/5 pr-5">
                    <button type="submit" className={style.loginBtn}>
                      <p className="m-auto">Save</p>
                    </button>{" "}
                  </div>
                </form>

                <div className={openTab === 2 ? "block" : "hidden"} id="link2">
                  {/* password settings */}
                  <div className="p-5 pl-0  flex flex-col w-full md:w-2/5">
                    <h2 className="font-semibold">Change password</h2>
                    <div className="flex flex-col">
                      {/* name field */}
                      <div className="py-2 w-full">
                        <label>Password </label>
                        <div className={style.field.parentDiv}>
                          <input
                            type="password"
                            className={style.field.input}
                          />
                        </div>
                      </div>
                      {/*  field */}
                      <div className="py-2  w-full">
                        <label>New Password </label>
                        <div className={style.field.parentDiv}>
                          <input
                            type="password"
                            className={style.field.input}
                          />
                        </div>
                      </div>
                      {/*  field */}
                      <div className="py-2  w-full">
                        <label>Confirm password </label>
                        <div className={style.field.parentDiv}>
                          <input
                            type="password"
                            className={style.field.input}
                          />
                        </div>
                      </div>
                      {/* reset password link */}
                      <div>
                        <Link to="/resetlink" className="text-indigo-600">
                          Forgot password
                        </Link>
                      </div>
                      {/* reset btn */}
                      <button type="submit" className={style.loginBtn}>
                        <p className="m-auto">Change Password</p>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  className={openTab === 3 ? "flex flex-col" : "hidden"}
                  id="link3"
                >
                  {/* project info */}
                  <div className="p-5 pl-0 pb-0 flex flex-col md:w-3/5">
                    <h2 className="font-semibold my-2">Project setting</h2>
                    <div className="md:flex md:flex-row flex flex-col">
                      {/* name field */}
                      <div className="py-2 w-full">
                        <label>Name </label>
                        <div className={style.field.parentDiv}>
                          <input
                            type="text"
                            defaultValue="RW0622"
                            className={style.field.input}
                          />
                        </div>
                      </div>
                      {/*  field */}
                      <div className="py-2 md:ml-2  w-full">
                        <label>Church </label>
                        <div className={style.field.parentDiv}>
                          <input
                            type="text"
                            defaultValue="Anglican"
                            className={style.field.input}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="md:flex md:flex-row flex flex-col">
                      {/*  field */}
                      <div className="py-2  w-full">
                        <label>Province </label>
                        <Select options={roles} />
                      </div>
                      {/*  field */}
                      <div className="py-2 md:ml-2 w-full">
                        <label>District </label>
                        <Select options={roles} />
                      </div>
                    </div>
                    <div className="md:flex md:flex-row flex flex-col">
                      {/* name field */}
                      <div className="py-2 w-full">
                        <label>Sector </label>
                        <div className={style.field.parentDiv}>
                          <input
                            type="text"
                            defaultValue="Kigabiro"
                            className={style.field.input}
                          />
                        </div>
                      </div>
                      {/* name field */}
                      <div className="py-2  md:ml-2 w-full">
                        <label>Cell </label>
                        <div className={style.field.parentDiv}>
                          <input
                            type="text"
                            defaultValue="Bwinsanga"
                            className={style.field.input}
                          />
                        </div>
                      </div>
                    </div>
                    <button type="submit" className={style.loginBtn}>
                      <p className="m-auto">Save</p>
                    </button>{" "}
                  </div>
                </div>
                <div
                  className={openTab === 4 ? "flex flex-col" : "hidden"}
                  id="link4"
                >
                  {/* project staff */}
                  <div className="w-full mt-10 h-auto p-5 pt-0 pl-0 rounded">
                    <div className="flex">
                      <h2 className="font-semibold my-2">Project employees</h2>
                      <div className="ml-auto">
                        <button
                          className="flex flex-row p-2  bg-indigo-500 text-white text-sm rounded"
                          onClick={() => {
                            return overlayController();
                          }}
                        >
                          {" "}
                          <span className="ml-2 text-xs">Add employee</span>
                        </button>
                      </div>
                    </div>
                    <div className="flex flex-col w-full">
                      {profile >= 1 ? (
                        <div>
                          <div
                            className={
                              "absolute mt-5 right-12 cursor-default mb-5 p-3 px-6 bg-white border border-blue-100 rounded pb-2 flex"
                            }
                            ref={profileCard}
                          >
                            <div className="flex flex-col md:flex">
                              <div>
                                <div className="flex flex-col">
                                  <div>
                                    <h2 className="text-indigo-500 font-semibold py-2">
                                      Profile for
                                      {" " + projectStaff[profile - 1].name}
                                    </h2>
                                  </div>
                                  <div className="w-20 font-semibold my-auto">
                                    Name
                                  </div>
                                  <p>{projectStaff[profile - 1].name}</p>
                                </div>
                                <div className="flex flex-col">
                                  <div className="w-20 font-semibold my-auto">
                                    Email
                                  </div>
                                  <p>{projectStaff[profile - 1].email}</p>
                                </div>
                                <div className="flex flex-col">
                                  <div className="w-20 font-semibold my-auto">
                                    Phone
                                  </div>
                                  <p>{projectStaff[profile - 1].tel}</p>
                                </div>
                                <div className="flex flex-col">
                                  <div className="w-20 font-semibold my-auto">
                                    Role
                                  </div>
                                  <p>{projectStaff[profile - 1].role}</p>
                                </div>
                              </div>
                              <div className="p-2 flex flex-row  m-auto md:ml-5 fit-content">
                                <button className={style.deleteBtn}>
                                  Block
                                </button>
                                <button
                                  className={style.changeBtn}
                                  onClick={() => {
                                    changeRoleOverlayController();
                                  }}
                                >
                                  Update
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        <div className="hidden"></div>
                      )}
                      {projectStaff.map((member, i) => {
                        return (
                          <div
                            className="flex flex-wrap border border-gray-100 p-4 my-2 bg-gray-50 rounded w-full hover:bg-gray-50 cursor-pointer"
                            key={i}
                            onClick={() => {
                              openProfile(i + 1);
                            }}
                          >
                            <img
                              src="https://i1.pngguru.com/preview/137/834/449/cartoon-cartoon-character-avatar-drawing-film-ecommerce-facial-expression-png-clipart.jpg"
                              className="w-10 h-10 rounded-full"
                              alt="member"
                            />
                            <div className="m-auto ml-2 w-40">
                              <h2 className="font-normal">{member.name}</h2>
                              <p className="font-semibold">{member.role} </p>
                            </div>
                            <div
                              className={
                                "ml-10 md:m-auto md:mr-4 flex flex-row flex-wrap bg-indigo-50 text-indigo-500  rounded p-1"
                              }
                            >
                              <div className="flex">
                                <span className="mr-1">From</span>
                                {member.startDate}{" "}
                                <div
                                  className={
                                    member.roleStatusActive ? "ml-0" : "hidden"
                                  }
                                >
                                  <span className="ml-2">To</span>
                                  {member.endDate}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className={openOverlay || openChangeRoleOverlay ? "block" : "hidden"}
      >
        <Overlay>
          <div className="p-10 bg-white m-auto  rounded w-80">
            <div className="flex">
              <h2 className="font-semibold my-2">
                {openOverlay
                  ? "Register new employee"
                  : "Assigning a role to a new employee"}
              </h2>
              <div className="m-auto mr-0">
                <button
                  className="flex flex-row p-1  bg-gray-300 hover:bg-gray-500 text-white text-sm rounded-full"
                  onClick={() => {
                    openOverlay
                      ? overlayController()
                      : changeRoleOverlayController();
                  }}
                >
                  <IoCloseOutline className="text-white" />{" "}
                </button>
              </div>
            </div>{" "}
            <div className="flex flex-col">
              {/* name field */}
              <div className="py-2 w-full">
                <label>Email </label>
                <div className={style.field.parentDiv}>
                  <input type="text" className={style.field.input} />
                </div>
              </div>
              {/*  field */}
              <div className="py-2  w-full">
                <label>Role </label>
                <Select options={roles} />
              </div>

              {/* save btn */}
              <button type="submit" className={style.loginBtn}>
                <p className="m-auto">Save</p>
              </button>
            </div>
          </div>
        </Overlay>
      </div>
    </DashLayout>
  );
}

export default SettingsAccount;
